module.exports = __webpack_public_path__ + "img/dropsmith-bogo.e0c88951.png";